var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v(" Получить микрозайм может любой гражданин РФ от 18 до 70 лет, который проживает "),_c('a',{staticClass:"txtLink",attrs:{"href":"pdf/География присутствия.pdf","target":"_blank"}},[_vm._v("в зоне обслуживания")]),_vm._v(" нашей компании. Необходимо наличие стабильного источника дохода, из документов нужен только паспорт. ")])
}]

export { render, staticRenderFns }